import React from 'react';
import cn from 'classnames';

import Modal from '../../../common/ui/Modal';
import CancellationItem from '../CancellationItem';

import styles from './styles.module.scss';

const StartCancellationModal = ({
  submitHandler,
  nextChargeDate,
  isOpen,
  onClose,
}) => {
  const nextChargeDay = nextChargeDate.replace(/,\s*\d+$/, '');
  const changeHandler = (value) => {
    submitHandler(value);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      preventClosing={true}
      className={styles.baseModal}
    >
      <h3 className={cn('h3', styles.title)}>We’re sorry to see you go :(</h3>
      <p className={styles.description}>
        Your cycle is set to renew on <b>{nextChargeDay}</b>, when would you
        like to cancel your subscription?
      </p>
      <ul className={styles.mainQuestionsList}>
        <li key="immediately">
          <CancellationItem
            onChange={() => changeHandler('immediate')}
            name="type"
            label="Cancel Immediately"
            value="immediately"
          ></CancellationItem>
        </li>
        <li key="scheduled">
          <CancellationItem
            onChange={() => changeHandler('scheduled')}
            name="type"
            label="Cancel at the End of Billing Cycle"
            value="scheduled"
          ></CancellationItem>
        </li>
      </ul>
    </Modal>
  );
};
export default StartCancellationModal;
